export const shoMenu = () => {
        let header__content_headphone = document.querySelector('.navbar');
        header__content_headphone.classList.toggle('toggle');
    }

